import { render, staticRenderFns } from "./AddPcontract.vue?vue&type=template&id=4aa8e124&scoped=true"
import script from "./AddPcontract.vue?vue&type=script&lang=js"
export * from "./AddPcontract.vue?vue&type=script&lang=js"
import style0 from "./AddPcontract.vue?vue&type=style&index=0&id=4aa8e124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8e124",
  null
  
)

export default component.exports